import { useEffect, useState } from "react";
import { getInfluxdbData } from "../../services/api/influxdb-tools";
import { Battery0Icon, Battery100Icon, Battery50Icon } from "@heroicons/react/24/solid";
import { isNumber } from "chart.js/helpers";
import { Tooltip } from "@heroui/react";


export const BatteryIndicator = ({ devicesNames }) => {
  const [remainingBattery, setRemainingBattery] = useState(undefined);

  // System is running or not
  useEffect(() => {
    const getData = async () => {
      const batteryData = await getInfluxdbData(
        'engine',
        'battery_information',
        [['client_id', '==', devicesNames]],
        ['battery_percentage'],
        '-3w',
        'now()',
        '1ms',
        null,
        'last',
        [],
        null,
        null,
        false,
        'desc',
      );
      if (batteryData.length > 0)
        setRemainingBattery(Math.floor(batteryData?.[0]?.value));
      else
        setRemainingBattery(null);
    };

    getData();
  }, []);

  const batteryColor = remainingBattery > 60 ? 'text-success' : remainingBattery > 30 ? 'text-warning' : 'text-error';
  const tooltipText = `Batterie restante : ${remainingBattery}%${remainingBattery < 30 ? ' - Pensez à recharger !' : ''}`;

  return (
    <>
      {isNumber(remainingBattery) ?
        <Tooltip content={tooltipText} showArrow={false} placement="bottom">
          <div className={`flex items-center gap-2 ${batteryColor}`}>
            {remainingBattery > 60 ? <Battery100Icon className="size-6"/> :
              remainingBattery > 30 ? <Battery50Icon className="size-6"/> :
                <Battery0Icon className="size-6"/>
            }
            <span className="mt-0.5">{remainingBattery}%</span>
          </div>
        </Tooltip>
      : remainingBattery === null ?
        <div className="flex items-center gap-3">
          <span className='relative flex w-3 h-3'>
            <span className='relative inline-flex w-3 h-3 rounded-full bg-perception-gray-500' />
          </span>
          <span>Système non connecté</span>
        </div>
      :
        <div/>
      }
    </>
  )
};